// Brevo-Anbindung: Status, API-Key, Absender, Kontakt-Sync, Testmail
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Zap, Loader2, Check, Users, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/brevo`;

export function BrevoPanel({ flash, onChanged }) {
  const [st, setSt] = useState(null);
  const [cfg, setCfg] = useState({ api_key: "", sender_email: "", sender_name: "" });
  const [testTo, setTestTo] = useState("");
  const [busy, setBusy] = useState("");
  const load = async () => {
    const r = await axios.get(`${API}/status`);
    setSt(r.data); setCfg((c) => ({ ...c, sender_email: r.data.sender_email || "", sender_name: r.data.sender_name || "" }));
  };
  useEffect(() => { load(); }, []);
  const run = async (key, fn, okMsg) => {
    setBusy(key);
    try { const r = await fn(); flash(okMsg(r)); await load(); onChanged && onChanged(); }
    catch (e) { flash(e.response?.data?.detail || "Brevo-Fehler"); }
    finally { setBusy(""); }
  };
  if (!st) return null;
  const acct = st.account;
  return (
    <div className="card space-y-2" data-testid="brevo-panel">
      <div className="flex items-center justify-between">
        <div className="overline flex items-center gap-1"><Zap size={12} /> Brevo (E-Mail-Marketing)</div>
        <span className="channel-pill" data-testid="brevo-status" style={{ background: st.configured ? (st.error ? "#F43F5E22" : "#10B98122") : "#374151", color: st.configured ? (st.error ? "#F43F5E" : "#10B981") : "#D1D5DB" }}>
          {!st.configured ? "Kein API-Key" : st.error ? "Fehler" : "Verbunden"}
        </span>
      </div>
      {acct && (
        <div className="text-[11px] text-eb-muted" data-testid="brevo-account">
          {acct.email}{acct.company ? ` · ${acct.company}` : ""} · Transaktional {acct.relay_enabled ? "aktiv" : "inaktiv"}
          {acct.plans?.map((p, i) => <span key={i}> · {p.type}{p.credits != null ? ` ${p.credits} Credits` : ""}</span>)}
          {st.list_id && <span> · Liste #{st.list_id}</span>}
        </div>
      )}
      {st.error && <div className="text-[11px] text-rose-400" data-testid="brevo-error">{st.error}</div>}
      <input type="password" placeholder={st.configured ? "API-Key •••• gespeichert (neuen eintragen zum Ersetzen)" : "Brevo API-Key (xkeysib-…)"} value={cfg.api_key}
        onChange={(e) => setCfg({ ...cfg, api_key: e.target.value })} data-testid="brevo-api-key" />
      <div className="grid grid-cols-2 gap-1">
        <input placeholder="Absender-Name" value={cfg.sender_name} onChange={(e) => setCfg({ ...cfg, sender_name: e.target.value })} data-testid="brevo-sender-name" />
        <input placeholder="Absender-E-Mail (in Brevo verifiziert)" value={cfg.sender_email} onChange={(e) => setCfg({ ...cfg, sender_email: e.target.value })} data-testid="brevo-sender-email" />
      </div>
      <button className="btn btn-primary w-full justify-center" disabled={busy || !cfg.sender_email} data-testid="brevo-save"
        onClick={() => run("save", () => axios.put(`${API}/config`, { ...cfg, api_key: cfg.api_key || null }), () => "✓ Brevo gespeichert")}>
        {busy === "save" ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} Speichern
      </button>
      <div className="grid grid-cols-2 gap-1">
        <button className="btn justify-center" disabled={busy || !st.configured} data-testid="brevo-sync-contacts"
          onClick={() => run("sync", () => axios.post(`${API}/contacts/sync`), (r) => `✓ ${r.data.synced} Kontakte zu Brevo synchronisiert${r.data.failed ? ` · ${r.data.failed} Fehler` : ""}`)}>
          {busy === "sync" ? <Loader2 size={14} className="animate-spin" /> : <Users size={14} />} Kontakte → Brevo
        </button>
        <div className="flex gap-1">
          <input placeholder="Testmail an …" value={testTo} onChange={(e) => setTestTo(e.target.value)} data-testid="brevo-test-to" />
          <button className="btn" disabled={busy || !testTo || !st.configured} data-testid="brevo-test-btn"
            onClick={() => run("test", () => axios.post(`${API}/test`, { to: testTo }), (r) => r.data.message)}>
            {busy === "test" ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
          </button>
        </div>
      </div>
      <div className="text-[10px] text-eb-muted">API-Key: Brevo → SMTP & API → API-Schlüssel. Absender muss in Brevo unter „Transactional → Senders“ verifiziert sein. Newsletter-Versand über Brevo: oben beim Versand-Server „Brevo“ wählen.</div>
    </div>
  );
}
